/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export type SsoLoginFormValues = {
  email: string;
};

export enum SsoLoginMode {
  Form = 'form',
  Option = 'option',
}
